/**
 * Helpers puros de subgrupos Zoom (testables sin el store del SDK).
 */

/** Tope de grupos por sesión pedido por el negocio (el SDK permite más). */
export const MAX_SUBSESSIONS = 20;

/** SubsessionAllocationPattern del SDK (valores literales). */
export const ALLOCATION = { AUTO: 1, MANUAL: 2 };

export const SUBSESSION_ERROR_HINTS = {
    7500: 'Los grupos de trabajo no están disponibles en esta sesión',
    7501: 'Se alcanzó el máximo de grupos permitidos',
    7502: 'El grupo seleccionado no es válido',
    7503: 'Hay un participante con ID inválido; vuelve a asignar y reabre',
    7504: 'Los grupos no están en el estado correcto para esta acción',
    7505: 'El participante no puede salir del grupo (solo el host decide)',
};

const ACCOUNT_DISABLE_RE = /not enabled|breakout|subsession.*(disabled|disable)|cuenta|habilitad/i;

/**
 * Zoom a veces reporta "account disabled" (7500) en open aunque create ya funcionó.
 * Si ya hay salas, no devolvemos ese mensaje engañoso.
 */
export const humanizeSubsessionError = (err, fallback, { hasRooms = false } = {}) => {
    const code = err?.errorCode;
    const raw = String(err?.reason || err?.message || '');
    const looksLikeAccountDisable = code === 7500 || ACCOUNT_DISABLE_RE.test(raw);

    if (looksLikeAccountDisable && hasRooms) {
        return 'No se pudieron abrir los grupos. Revisa las asignaciones e inténtalo de nuevo.';
    }
    if (SUBSESSION_ERROR_HINTS[code]) return SUBSESSION_ERROR_HINTS[code];
    if (raw && !looksLikeAccountDisable) return raw;
    if (looksLikeAccountDisable) return SUBSESSION_ERROR_HINTS[7500];
    return fallback;
};

/** Payload mínimo que espera openSubsessions. */
export const toOpenPayload = (list) => (list || []).map((room) => ({
    subsessionId: room.subsessionId,
    subsessionName: room.subsessionName,
    userList: (room.userList || [])
        .map((u) => ({ userId: Number(u.userId) }))
        .filter((u) => Number.isFinite(u.userId)),
}));

export const resolveSupported = ({
    roomCount = 0,
    featureConfirmed = false,
    sdkEnabled = true,
} = {}) => {
    if (roomCount > 0 || featureConfirmed) return true;
    return sdkEnabled !== false;
};
